import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomMainContent, CardAnalyticsXl } from "../../components";
import CardAnalytics from "../../components/common/CardAnalytics";
import { getAverageCorrectAnswers, getAverageRepetitionsforUser, getUsersPerTime } from "../../redux/helpers";
import { CardRadialBar, CardLineChart, CardUsersPerProyect, CardRepeatPerUser } from "../common";
import { HelpButtonsTraining } from "./templates/HelperButtonsTraining";

const TrainingDashboard = () => {
    const { arrayData } = useSelector(state => state.table)
    const [averageResponses, setAverageResponses] = useState(0)
    const [repetByUsers, setRepetByUsers] = useState(0)
    const [numberusersInTime, setNumberusersInTime] = useState([])
    useEffect(() => {
        setAverageResponses(getAverageCorrectAnswers(arrayData))
        setRepetByUsers(getAverageRepetitionsforUser(arrayData));
        setNumberusersInTime(getUsersPerTime(arrayData))
        // setNumberusersInTime()
    }, [arrayData])

    const onFilterAverageResponses = (starDate, endDate) => {
        setAverageResponses(getAverageCorrectAnswers(arrayData, starDate, endDate))
    }
    const onfFilterRepeatByUsers = (starDate, endDate) => {
        setRepetByUsers(getAverageRepetitionsforUser(arrayData, starDate, endDate))
    }
    const onFilterNumberUsersInTime = (starDate, endDate, jumps) => {
        setNumberusersInTime(getUsersPerTime(arrayData, jumps, starDate, endDate))
    }

    return (
        <CustomMainContent>
            <div className="flex w-full min-w-[450px] h-full ">
                <div className="w-100-68 overflow-y-auto">
                    <div className="flex flex-wrap w-full overflow-y-auto">
                        <CardAnalytics title="Porcentaje promedio completado por persona" callbackDate={onFilterAverageResponses} >
                            <CardRadialBar averageResponses={averageResponses ? averageResponses : 0}></CardRadialBar>
                        </CardAnalytics>
                        <CardAnalytics title="Repeticiones hechas por persona" callbackDate={onfFilterRepeatByUsers} bottomText="10% desde ultima semana" >
                            <CardRepeatPerUser repetByUsers={repetByUsers ? repetByUsers : 0} />
                        </CardAnalytics>
                        <CardAnalyticsXl title="Nuevos usuarios" callbackDate={onFilterNumberUsersInTime} >
                            <CardLineChart usersInTime={numberusersInTime}></CardLineChart>
                        </CardAnalyticsXl>
                        <CardAnalyticsXl title="Número total de personas registradas en cada capacitación" bottomText="10% desde ultima semana">
                            <CardUsersPerProyect></CardUsersPerProyect>
                        </CardAnalyticsXl>
                    </div>
                </div>
                <div className="w-[68px] h-full flex justify-center">
                    <HelpButtonsTraining />
                </div>
            </div>
        </CustomMainContent>
    );
};

export default TrainingDashboard;
